
import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';

/**
 * Hook for showing toasts related to throttled admin actions
 */
export const useAdminToast = (isActionThrottled: boolean) => {
  const { toast } = useToast();
  
  // Show toast when actions are throttled
  useEffect(() => {
    if (isActionThrottled) {
      toast({
        title: "Thao tác quá nhanh",
        description: "Vui lòng chờ một chút trước khi thực hiện thao tác tiếp theo.",
        variant: "info" // Changed from "warning" to "info" which is an allowed variant
      });
    }
  }, [isActionThrottled, toast]);
};
